import Http from '../../../http';

export const notifyBarbersBankAccount = (shopId, barberIdsToNotify) => Http.post(
  `/shop/${shopId}/notify-barbers`,
  {
    topic: 'missing-bank-account',
    barberIds: barberIdsToNotify,
  }
);
